import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConsultaCorrecoesErrosCteModelRequest } from 'src/app/@feature/documentos-fiscais/acompanhamento-correcoes-erros-cte/acompanhamento-correcoes-erros-cte.model';
import { BaseCrudService, montarQueryString } from '../base-crud/base-crud.service';

@Injectable({
  providedIn: 'root'
})
export class CorrecoesErrosCteService extends BaseCrudService{

  /*
  Informar a rota do Controller correspondente na API
  */
  apiController = "GestaoCTe";

  /*
  URLS principais
  */
  consultarUrl = (input: ConsultaCorrecoesErrosCteModelRequest) => `CarregarLotes?${montarQueryString(input)}`;
  excelUrl = (input: ConsultaCorrecoesErrosCteModelRequest) => `ExportarExcel_ConsultaCorrecaoLoteErroCTe?${montarQueryString(input)}`;
  atualizarUrl = (input: any) => `Atualizar`;
  cadastrarUrl = (input: any) => `Cadastrar`;

  constructor(http: HttpClient) { super(http);  }

  public filtrosDetalhes(obj: any): Observable<any> {
    return this.http.get<any>(`${this.apiController}\\ObterFiltroDeTotalizadores?${montarQueryString(obj)}`);
  }
  public consultaDetalhes(obj: any): Observable<any> {
    return this.http.get<any>(`${this.apiController}\\CarregarLotesItem?${montarQueryString(obj)}`);
  }
  public acoesCte(): Observable<any> {
    return this.http.get<any>(`${this.apiController}\\ConsultaAcoesCTE`);
  }
  public statusCancelamento(): Observable<any> {
    return this.http.get<any>(`${this.apiController}\\StatusLote`);
  }
  // public statusCancelamento(): Observable<any> {
  //   return this.http.get<any>(`${this.apiController}\\ConsultaStatusCancelamento`);
  // }
  public listaUsuarios(): Observable<any> {
    return this.http.get<any>(`Usuario`);
  }
  public exportarExcelDetalhes(obj: any): Observable<any> {
    return this.http.get<any>(`${this.apiController}\\ExportarCorrecaoLoteErroCTeDetalhes?${montarQueryString(obj)}`);
  }
}
